import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { SD_TSmartData } from '../SD/SD.types'

export function IDB_smartDataRead(id: number | string) {
    return IDB_rowRead<SD_TSmartData>(IDB_globalDb, 'smart_data', id)
}

export function IDB_smartDatasDelete(ids: Array<number | string>) {
    return IDB_rowsDelete(IDB_globalDb, 'smart_data', ids)
}

export function IDB_smartDatasReadAll() {
    return IDB_rowsReadAll<SD_TSmartData>(IDB_globalDb, 'smart_data')
}

export function IDB_smartDatasWrite(smartDatas: SD_TSmartData[]) {
    return IDB_rowsWrite(IDB_globalDb, 'smart_data', smartDatas)
}
